import React, { useCallback, useState } from 'react'
import AutoComplete from '../formComponents/AutoComplete'
import PopUpIcon from '../formComponents/PopUpIcon'
import { getsearchcDropdownValuesNL } from '../../NL_App/api/getNLForm'
import {getsearchcDropdownValuesUK} from '../../GB_App/api/getGBForm'
import { useTranslation } from "@hooks/useTranslation";

export const AddDropdown = (props) => {
  const [addList, setAddList] = useState([])
  const { type } = props
  const translate = useTranslation();
  const getAddValue = useCallback(async (value) => {
    let response;
    if(props.country && props.country=="UK-CDS"){
      response= await getsearchcDropdownValuesUK(type,value,props.shipmentType);
      response = response?.data?.eventMessage[`${type}`] || [];

    }else{


     response = await getsearchcDropdownValuesNL(type, value);
    response = response?.data?.eventMessage[`${type}`] || [];

    }
    

    setAddList(response)
  }, [])
  return (
    <AutoComplete
      minCharacters={1}
      containerClass={props.country&&props.country=="UK-CDS"?"containerClass":''}
      labelIcon={<PopUpIcon icon='info circle' popupText={translate('SEARCHABLE_DROPDOWN_POPUP')} />}
      {...props}
      renderItem={({ value, text }) => {
        return (
          <span style={{ fontWeight: 'bold' }} className='text'>
            {`${value} - ${text}`}
          </span>
        )
      }}
      dataSource={addList}
      onSearchChange={getAddValue}
    />
  )
}
